var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shimmer rounded-lg absolute"},[_c('div',{class:[
      _vm.$store.state.theme.isDarkMode ? 'shimmer-line-dark' : 'shimmer-line',
    ]})])
}
var staticRenderFns = []

export { render, staticRenderFns }